import type { AxiosResponse } from 'axios';
import { appAxios } from 'utils/appAxios';
import { incidentsApi } from './api';
import type { IncidentsResponse } from './incidents_response_type';

export type IncidentsSearchResponse = Required<{
  incidents: IncidentsResponse[];
}>;

export const getIncidents = async (): Promise<AxiosResponse> => {
  return await appAxios.get(incidentsApi.path);
};
